<template>
  <div>
    <h3>{{ modalTitle }}</h3>
    <div
      v-if="hasQuickTagRemoval"
      class="Tag-container"
    >
      <div v-if="tags.length">
        <span
          v-for="tag in tags"
          :key="tag.slug"
          class="Tag Tag--orange"
        >
          {{ tag.name }}
          <i
            class="fa fa-times"
            @click="$emit('rmp:tag-selector:remove-tag', tag)"
          />
        </span>
      </div>
    </div>
    <search-input
      v-if="isSearchable"
      v-model="searchTerm"
      :has-icon="true"
      icon="fa fa-right fa-search"
      placeholder="Search tags"
      @input="searchTags"
    />
  </div>
</template>

<script>
import Input from '../../../form/input.vue';

export default {
  components: {
    'search-input': Input,
  },
  props: {
    modalTitle: {
      type: String,
      default: null,
    },
    tags: {
      type: Array,
      default() {
        return [];
      },
    },
    hasQuickTagRemoval: {
      type: Boolean,
      default: true,
    },
    isSearchable: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['rmp:tag-selector:remove-tag', 'rmp:tag-selector:search-input'],
  data() {
    return {
      searchTerm: '',
    };
  },
  methods: {
    searchTags() {
      this.$emit('rmp:tag-selector:search-input', this.searchTerm);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../scss/abstracts/abstracts.scss';
.Tag-container {
  margin: 10px 0;
  @include respond-to(sm, max-width) {
    max-height: 14vh;
    overflow: auto;
    overflow-x: hidden;
  }
  .Tag {
    margin: 3px 5px 0 0;
    //padding: 5px;
  }
}
</style>
